import BackendQuery from 'decentralized/BackendQuery.js';
import {
    SampleInSequence,
    TokenizedSequenceEdited
} from 'decentralized/EthereumEvents.js';
import TokenizedSequencesContract from 'decentralized/contracts/TokenizedSequencesContract.js';

const contractAddress = new TokenizedSequencesContract().contractAddress;

export const getProjectsUsed = async (id) => {
    let query = new BackendQuery(contractAddress)
        .from(SampleInSequence)
        .select("sequenceHash")
        .where("sampleHash", id);

    let results = await query.executeQuery();
    let hashes = results.map(x => x.sequenceHash);

    query = new BackendQuery(contractAddress)
        .from(TokenizedSequenceEdited)
        .select("title")
        .select("newSequence")
        .whereIn("newSequence", hashes);

    return await query.executeQuery();
};
